import { render, staticRenderFns } from "./cert-status.vue?vue&type=template&id=be9585ba&"
import script from "./cert-status.vue?vue&type=script&lang=js&"
export * from "./cert-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports